<div class="flex flex-col gap-[24px]">
  <ng-container *ngIf="installationDetailsStore.getMainDevicePlatform() | async as platformType">
    <ng-container *ngIf="platformType === platform.Legacy; else showDataForE3">
      <app-legacy-device-note
        [header]="'+ACTIVE_ERROR_DETAILS_PAGE.FREEZE_FRAME.HEADER' | translate"
      >
      </app-legacy-device-note>
      <app-legacy-device-note [header]="'+ACTIVE_ERROR_DETAILS_PAGE.LIVE_VDD.HEADER' | translate">
      </app-legacy-device-note>
    </ng-container>

    <ng-template #showDataForE3>
      <ng-container *ngIf="!isActiveSessionAvailable; else showData">
        <app-active-error-blur
          data-at-active-error-freeze-frame
          data-at-blur
          [header]="'+ACTIVE_ERROR_DETAILS_PAGE.FREEZE_FRAME.HEADER' | translate"
          [section]="activeErrorDetailsSections.FreezeFrame"
          [isHeaderInside]="false"
          [isStartDiagnosticsSessionButton]="true"
        ></app-active-error-blur>
        <app-active-error-blur
          data-at-active-error-live-vdd
          data-at-blur
          [header]="'+ACTIVE_ERROR_DETAILS_PAGE.LIVE_VDD.HEADER' | translate"
          [section]="activeErrorDetailsSections.LiveVdd"
          [isHeaderInside]="false"
        ></app-active-error-blur>
      </ng-container>

      <ng-template #showData>
        <app-active-error-blur
          *ngIf="dataAtTheTimeOfFaultDetectionError$ | async; else showFreezeFrame"
          [header]="'+ACTIVE_ERROR_DETAILS_PAGE.FREEZE_FRAME.HEADER' | translate"
          [section]="activeErrorDetailsSections.FreezeFrame"
          [isHeaderInside]="false"
          [isFreezeFrameErrorOccurred]="true"
        ></app-active-error-blur>
        <ng-template #showFreezeFrame>
          <app-freeze-frame></app-freeze-frame>
        </ng-template>

        <app-active-error-blur
          *ngIf="isAnyOfTheOtxVddSequenceInError$ | async; else showLiveVdd"
          [header]="'+ACTIVE_ERROR_DETAILS_PAGE.LIVE_VDD.HEADER' | translate"
          [section]="activeErrorDetailsSections.LiveVdd"
          [isHeaderInside]="false"
          [isLiveVddErrorOccurred]="true"
        ></app-active-error-blur>
        <ng-template #showLiveVdd>
          <app-show-live-vdd></app-show-live-vdd>
        </ng-template>
      </ng-template>
    </ng-template>
  </ng-container>
</div>
